module.exports = __webpack_public_path__ + "static/media/266.f476da13.svg";